module.exports = __webpack_public_path__ + "static/img/UA.5ba6ef26.png";